'use strict';exports.__esModule = true;exports.deleteMyPropertyByProject = exports.addPropetiesToProject = exports.loadPropertyTypes = exports.addNewProject = exports.editMyProject = exports.editMyPropertyByProject = exports.myPropertyByProject = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var addNewProject = (0, _reduxAct.createAction)('/ADD_NEW_PROJECT');
var addNewProjectSuccess = (0, _reduxAct.createAction)('/ADD_NEW_PROJECT_SUCCESS');
var addNewProjectFail = (0, _reduxAct.createAction)('/ADD_NEW_PROJECT_FAIL');

var addPropetiesToProject = (0, _reduxAct.createAction)('/ADD_PROPPERTIES_TO_PROJECT');
var addPropetiesToProjectSuccess = (0, _reduxAct.createAction)('/ADD_PROPPERTIES_TO_PROJECT_SUCCESS');
var addPropetiesToProjectFail = (0, _reduxAct.createAction)('/ADD_PROPPERTIES_TO_PROJECT_FAIL');

var loadPropertyTypes = (0, _reduxAct.createAction)('/LOAD_PROPERTY_TYPES');
var loadPropertyTypesSuccess = (0, _reduxAct.createAction)('/LOAD_PROPERTY_TYPES_SUCCESS');
var loadPropertyTypesFail = (0, _reduxAct.createAction)('/LOAD_PROPERTY_TYPES_FAIL');

var editMyProject = (0, _reduxAct.createAction)('/EDIT_MY_PROJECT');
var editMyProjectSuccess = (0, _reduxAct.createAction)('/EDIT_MY_PROJECT_SUCCESS');
var editMyProjectFail = (0, _reduxAct.createAction)('/EDIT_MY_PROJECT_FAIL');

var myPropertyByProject = (0, _reduxAct.createAction)('/MY_PROPERTY_BY_PROJECT');
var myPropertyByProjectSuccess = (0, _reduxAct.createAction)('/MY_PROPERTY_BY_PROJECT_SUCCESS');
var myPropertyByProjectFail = (0, _reduxAct.createAction)('/MY_PROPERTY_BY_PROJECT_FAIL');

var editMyPropertyByProject = (0, _reduxAct.createAction)('/EDIT_MY_PROPERTY_BY_PROJECT');
var editMyPropertyByProjectSuccess = (0, _reduxAct.createAction)('/EDIT_MY_PROPERTY_BY_PROJECT_SUCCESS');
var editMyPropertyByProjectFail = (0, _reduxAct.createAction)('/EDIT_MY_PROPERTY_BY_PROJECT_FAIL');

var deleteMyPropertyByProject = (0, _reduxAct.createAction)('/DELETE_MY_PROPERTY_BY_PROJECT');
var deleteMyPropertyByProjectSuccess = (0, _reduxAct.createAction)('/DELETE_MY_PROPERTY_BY_PROJECT_SUCCESS');
var deleteMyPropertyByProjectFail = (0, _reduxAct.createAction)('/DELETE_MY_PROPERTY_BY_PROJECT_FAIL');

var initialState = {
    data: null,
    propertyTypes: [],
    loaded: false,
    loading: false,
    loadingByProperty: false,
    properties: null };


var fetchLoad = function fetchLoad() {return (
        (0, _axios2.default)({
            method: 'get',
            url: '/property-types' }).

        then(loadPropertyTypesSuccess, loadPropertyTypesFail));};

var handleLoadPropertyTypes = function handleLoadPropertyTypes(state) {return (0, _reduxLoop.loop)(Object.assign({}, state), promise(fetchLoad));};

var handleLoadPropertyTypesSuccess = function handleLoadPropertyTypesSuccess(state, _ref) {var data = _ref.data;return Object.assign({},
    state, {
        propertyTypes: data });};


var handleLoadPropertyTypesFail = function handleLoadPropertyTypesFail(state, _ref2) {var data = _ref2.data;return Object.assign({},
    state, {
        error: true });};


var fetchAddNewProject = function fetchAddNewProject(_ref3) {var data = _ref3.data,token = _ref3.token;return (
        _axios2.default.post('/projects/my', data, { headers: { access_token: token } }).
        then(addNewProjectSuccess, addNewProjectFail));};

var handleAddNewProject = function handleAddNewProject(state, data) {return (
        (0, _reduxLoop.loop)(Object.assign({}, state, { loaded: false, loading: true }), promise(fetchAddNewProject, data)));};

var handleAddNewProjectSuccess = function handleAddNewProjectSuccess(state, _ref4) {var data = _ref4.data;return Object.assign({},
    state, {
        loaded: true,
        loading: false,
        data: data });};


var handleAddNewProjectFail = function handleAddNewProjectFail(state, _ref5) {var response = _ref5.response;
    var error = response.data;

    return Object.assign({},
    state, {
        loaded: false,
        loading: false,
        error: error });

};

var handleAddPropetiesSuccess = function handleAddPropetiesSuccess(state, _ref6) {var data = _ref6.data;return Object.assign({},
    state, {
        loaded: true,
        loading: false });};


var handleAddPropetiesFail = function handleAddPropetiesFail(state, _ref7) {var response = _ref7.response;
    var error = response.data;

    return Object.assign({},
    state, {
        loaded: false,
        loading: false,
        error: error });

};

var fetchAddProperties = function fetchAddProperties(_ref8) {var data = _ref8.data,token = _ref8.token,id = _ref8.id;return (
        _axios2.default.post('/projects/' + id + '/properties', data, { headers: { access_token: token } }).
        then(addPropetiesToProjectSuccess, addPropetiesToProjectFail));};

var handleAddProperties = function handleAddProperties(state, data) {return (
        (0, _reduxLoop.loop)(Object.assign({}, state, { loaded: false, loading: true }), promise(fetchAddProperties, data)));};

var fetchEditProjects = function fetchEditProjects(_ref9) {var data = _ref9.data,token = _ref9.token,id = _ref9.id;return (
        _axios2.default.put('/projects/' + id, data, { headers: { access_token: token } }).
        then(editMyProjectSuccess, editMyProjectFail));};

var handleEditMyProject = function handleEditMyProject(state, data) {return (
        (0, _reduxLoop.loop)(Object.assign({}, state, { loaded: false, loading: true }), promise(fetchEditProjects, data)));};

var handleEditMyProjectSuccess = function handleEditMyProjectSuccess(state, _ref10) {var data = _ref10.data;return Object.assign({},
    state, {
        data: data,
        loaded: true,
        loading: false });};


var handleEditMyProjectFail = function handleEditMyProjectFail(state) {return Object.assign({},
    state, {
        loaded: true,
        loading: false,
        error: true });};


var fetchMyPropertyByProject = function fetchMyPropertyByProject(_ref11) {var id = _ref11.id;return (
        _axios2.default.get('/projects/' + id + '/properties').
        then(myPropertyByProjectSuccess, myPropertyByProjectFail));};

var handleMyPropertyByProject = function handleMyPropertyByProject(state, data) {return (
        (0, _reduxLoop.loop)(Object.assign({}, state, { error: null, loadingByProperty: true, properties: null }),
        promise(fetchMyPropertyByProject, data)));};

var handleMyPropertyByProjectSuccess = function handleMyPropertyByProjectSuccess(state, _ref12) {var data = _ref12.data;return Object.assign({},
    state, {
        properties: data,
        loadingByProperty: false });};


var handleMyPropertyByProjectFail = function handleMyPropertyByProjectFail(state) {return Object.assign({},
    state, {
        error: true,
        loadingByProperty: false });};


var fetchEditMyPropertyByProject = function fetchEditMyPropertyByProject(_ref13) {var project_id = _ref13.project_id,property_id = _ref13.property_id,data = _ref13.data,token = _ref13.token;return (
        _axios2.default.put('projects/' + project_id + '/properties/' + property_id + ' ', data, { headers: { access_token: token } }).
        then(editMyPropertyByProjectSuccess, editMyPropertyByProjectFail));};

var handleEditMyPropertyByProject = function handleEditMyPropertyByProject(state, data) {return (
        (0, _reduxLoop.loop)(Object.assign({}, state, { loaded: false, error: null, properties: null }), promise(fetchEditMyPropertyByProject, data)));};

var handleEditMyPropertyByProjectSuccess = function handleEditMyPropertyByProjectSuccess(state, _ref14) {var data = _ref14.data;return Object.assign({},
    state, {
        properties: null,
        loaded: true });};


var handleEditMyPropertyByProjectFail = function handleEditMyPropertyByProjectFail(state) {return Object.assign({},
    state, {
        error: true });};


var fetchDeleteMyPropertyByProject = function fetchDeleteMyPropertyByProject(_ref15) {var project_id = _ref15.project_id,property_id = _ref15.property_id,token = _ref15.token;return (
        _axios2.default.delete('projects/' + project_id + '/properties/' + property_id + ' ', { headers: { access_token: token } }).
        then(deleteMyPropertyByProjectSuccess, deleteMyPropertyByProjectFail));};

var handleDeleteMyPropertyByProject = function handleDeleteMyPropertyByProject(state, data) {return (
        (0, _reduxLoop.loop)(Object.assign({}, state, { error: null }), promise(fetchDeleteMyPropertyByProject, data)));};

var handleDeleteMyPropertyByProjectSuccess = function handleDeleteMyPropertyByProjectSuccess(state) {return Object.assign({}, state);};

var handleDeleteMyPropertyByProjectFail = function handleDeleteMyPropertyByProjectFail(state) {return Object.assign({},
    state, {
        error: true });};


var creationNewHomes = (0, _reduxAct.createReducer)(function (on) {
    on(addNewProject, handleAddNewProject);
    on(addNewProjectSuccess, handleAddNewProjectSuccess);
    on(addNewProjectFail, handleAddNewProjectFail);

    on(addPropetiesToProject, handleAddProperties);
    on(addPropetiesToProjectSuccess, handleAddPropetiesSuccess);
    on(addPropetiesToProjectFail, handleAddPropetiesFail);

    on(loadPropertyTypes, handleLoadPropertyTypes);
    on(loadPropertyTypesSuccess, handleLoadPropertyTypesSuccess);
    on(loadPropertyTypesFail, handleLoadPropertyTypesFail);

    on(editMyProject, handleEditMyProject);
    on(editMyProjectSuccess, handleEditMyProjectSuccess);
    on(editMyProjectFail, handleEditMyProjectFail);

    on(myPropertyByProject, handleMyPropertyByProject);
    on(myPropertyByProjectSuccess, handleMyPropertyByProjectSuccess);
    on(myPropertyByProjectFail, handleMyPropertyByProjectFail);

    on(editMyPropertyByProject, handleEditMyPropertyByProject);
    on(editMyPropertyByProjectSuccess, handleEditMyPropertyByProjectSuccess);
    on(editMyPropertyByProjectFail, handleEditMyPropertyByProjectFail);

    on(deleteMyPropertyByProject, handleDeleteMyPropertyByProject);
    on(deleteMyPropertyByProjectSuccess, handleDeleteMyPropertyByProjectSuccess);
    on(deleteMyPropertyByProjectFail, handleDeleteMyPropertyByProjectFail);
}, initialState);exports.


myPropertyByProject = myPropertyByProject;exports.
editMyPropertyByProject = editMyPropertyByProject;exports.
editMyProject = editMyProject;exports.
addNewProject = addNewProject;exports.
loadPropertyTypes = loadPropertyTypes;exports.
addPropetiesToProject = addPropetiesToProject;exports.
deleteMyPropertyByProject = deleteMyPropertyByProject;exports.default =


creationNewHomes;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/creationNewHomes.js
// module id = 585
// module chunks = 0